import { useTheme } from '@/store/theme';

/**
 * Night Souq / Day Souq switch. Sun in day, moon in night; the whole control
 * cross-fades and the saffron ring glows on hover. Persists via the theme store.
 */
export function ThemeToggle() {
  const theme = useTheme((s) => s.theme);
  const toggle = useTheme((s) => s.toggle);
  const night = theme === 'night';

  return (
    <button
      onClick={toggle}
      aria-label={night ? 'Switch to Day Souq' : 'Switch to Night Souq'}
      title={night ? 'Day Souq' : 'Night Souq'}
      className="relative w-9 h-9 rounded-full grid place-items-center text-mute hover:text-gold hover:bg-cream-deep transition group overflow-hidden"
    >
      <span className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition"
        style={{ boxShadow: '0 0 0 1px rgb(var(--glow) / 0.4), 0 0 16px -2px rgb(var(--glow) / 0.5)' }} />
      {/* Sun */}
      <svg className={`w-5 h-5 absolute transition-all duration-500 ${night ? 'opacity-0 rotate-90 scale-50' : 'opacity-100 rotate-0 scale-100 text-gold-dark'}`}
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
      </svg>
      {/* Moon */}
      <svg className={`w-5 h-5 absolute transition-all duration-500 ${night ? 'opacity-100 rotate-0 scale-100 text-gold' : 'opacity-0 -rotate-90 scale-50'}`}
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
      </svg>
    </button>
  );
}
